/**
 * Status and code only, for logs. A raw AxiosError serializes its request
 * config, whose headers carry the Bearer token, so it must never be logged.
 */
export const errorSummary = (
  error: unknown
): { status?: number; code?: string } => {
  if (!error || typeof error !== "object") return {};
  const { response, code } = error as {
    response?: { status?: unknown };
    code?: unknown;
  };
  return {
    status: typeof response?.status === "number" ? response.status : undefined,
    code: typeof code === "string" ? code : undefined
  };
};
